// Common component pieces for Browse views
import { mapGetters, mapMutations } from 'vuex';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import routingMixin from '@/mixins/routing';
import linksMixin from '@/mixins/links';
import Types from '../../foodItem-types';
import Access from '../../access';

const constMaxDescChars = 50;

export default {
  mixins: [routingMixin, linksMixin],
  methods: {
    ...mapMutations('browse', {
      toggleSort: 'toggleSort',
    }),
    descClicked(fi) {
      this.$emit('descClicked', fi);
    },
    truncateDesc(desc) {
      if (desc.length > constMaxDescChars) {
        return `${desc.substring(0, constMaxDescChars)}...`;
      }
      return desc;
    },
    typeIcon(id) {
      return this.types.getType(id).icon;
    },
    accessIcon(accessId) {
      return Access[accessId].icon;
    },
  },
  computed: {
    ...mapGetters({
      foodItems: 'browse/foodItems',
      sort: 'browse/sort',
    }),
    sortField() {
      return this.sort.field;
    },
    maxDescChars() {
      return constMaxDescChars;
    },
    types() {
      return Types;
    },
    sortIcon() {
      return this.sort.order === 'asc' ? 'sort-up' : 'sort-down';
    },
  },
  components: {
    FontAwesomeIcon,
  },
};



// WEBPACK FOOTER //
// ./src/components/browse/BrowseMixin.js